import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CandidateApplicationFormComponent } from './common/candidate-application-form/candidate-application-form.component';
import { CandidateApplicationForm1Component } from './common/candidate-application-form1/candidate-application-form1.component';
import { SuccessComponent } from './common/success/success.component';
import { TermsAndConditionsFirstFormComponent } from './common/terms-and-conditions-first-form/terms-and-conditions-first-form.component';
import { TermsAndConditionsSecondFormComponent } from './common/terms-and-conditions-second-form/terms-and-conditions-second-form.component';
import { FailedComponent } from './common/failed/failed.component';
import { JobDetailsComponent } from './common/job-details/job-details.component';
import { JobsComponent } from './common/jobs/jobs.component';
import { Error404Component } from './common/error404/error404.component';
import { UpdateComponent } from './common/update/update.component';

const routes: Routes = [
  {
    path: 'applicationform_part_1/:id',
    component: CandidateApplicationFormComponent
  },
  {
    path: 'applicationform_part_2/:token',
    component: CandidateApplicationForm1Component
  },
  {
    path: 'success',
    component: SuccessComponent
  },
  {
    path: 'terms-and-conditions-first-form',
    component: TermsAndConditionsFirstFormComponent
  },
  {
    path: 'terms-and-conditions-second-form',
    component: TermsAndConditionsSecondFormComponent
  },
  {
    path: 'failed',
    component: FailedComponent
  },
  {
    path: 'update',
    component: UpdateComponent
  },
  {
    path: 'job-details/:id',
    component: JobDetailsComponent
  },
  {
    path: 'job-list',
    component: JobsComponent
  },
  {
    path: '',
    redirectTo: '/job-list',
    pathMatch: 'full'
  },
  {
    path: '404',
    component: Error404Component,
    data: {title: 'Not Found'}
  },
  {
    path: '**',
    redirectTo: '/404'
  },
];

@NgModule({
  exports: [ RouterModule ],
  imports: [ RouterModule.forRoot(routes) ],
})
export class AppRoutingModule {}
